import axios from "axios";
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { config1 } from "../config/config";
import { BASEURL } from "../config/config";
import Header from "../compount/Header";
import { AppContext, useAppContext } from "../context/context";
import { useIsOnline } from "../hooks/useIsOnline";
import intercepter from "../server/intercepter";
import { SafeImage } from "../compount/helper/SafImage";
import MessageModal from "../utlity/MessageModal";
import { getS3Url } from "../utlity/utlityFunctions";

function Post({ pageType }) {
  const [pic, setPic] = useState("/images/uplodeImg.jpg");
  const [image, setImage] = useState();
  const [title, setTitle] = useState();
  const [loading, setLoading] = useState(false);
  const { state } = useAppContext(AppContext);

  const [toast, setToast] = useState({
    show: false,
    message: "",
    type: "",
  });

  const nav = useNavigate();
  const isOnline = useIsOnline();
  //========================= image resize ==========================//

  const [invalidImage, setinvalidImage] = useState(null);
  let reader = new FileReader();
  const handleInputChange = (event) => {
    const imageFile = event.target.files[0];
    const imageFilname = event.target.files[0].name;

    if (!imageFile) {
      setinvalidImage("Please select image.");
      return false;
    }

    if (!imageFile.name.match(/\.(jpg|jpeg|png|JPG|JPEG|PNG|gif)$/)) {
      setinvalidImage("Please select valid image JPG,JPEG,PNG");
      return false;
    }
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        //------------- Resize img code ------------------------//
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        var MAX_WIDTH = 500;
        var MAX_HEIGHT = 500;
        var width = img.width;
        var height = img.height;

        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
          }
        }
        canvas.width = width;
        canvas.height = height;

        ctx.drawImage(img, 0, 0, width, height);
        ctx.canvas.toBlob(
          (blob) => {
            const file = new File([blob], imageFilname, {
              type: "image/jpeg",
              lastModified: Date.now(),
            });
            setImage(file);
            setPic(URL.createObjectURL(imageFile));
          },
          "image/jpeg",
          1,
        );
        setinvalidImage(null);
      };
      img.onerror = () => {
        setinvalidImage("Invalid image content.");
        return false;
      };
      //debugger
      img.src = e.target.result;
    };
    reader.readAsDataURL(imageFile);
  };
  //========================= image resize close ==========================//

  const postFeatch = async () => {
    if (!title) {
      // return alert("add the title");
      return setToast({
        show: true,
        type: "none",
        message: "add the title",
      });
    }
    const data = new FormData();
    data.append("photo", image);
    data.append("title", title);

    if (image) {
      try {
        setLoading(true);
        const resPost = await intercepter.post(
          `${BASEURL}/post/createNewPost`,
          data,
          config1,
        );
        // alert("successfull");
        setToast({
          show: true,
          type: "create",
          message: "created successfull",
        });
        nav("/");
      } catch (error) {
        console.log(error);
        // alert("failed");

        setToast({
          show: true,
          type: "none",
          message: "failed",
        });
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, [2000]);
      }
    } else {
      // alert("add image");

      setToast({
        show: true,
        type: "none",
        message: "add image",
      });
    }
  };

  const postStory = async () => {
    if (!image) {
      return setToast({
        show: true,
        type: "none",
        message: "please add image or video",
      });
      // return alert("please add image");
    }
    const data = new FormData();
    data.append("photo", image);
    if (title) {
      data.append("title", title);
    }

    try {
      if (!isOnline) {
        setToast({
          show: true,
          type: "none",
          message: "No internet connection. Please check your network.",
        });
        // alert("No internet connection. Please check your network.");
        return;
      }
      setLoading(true);

      const resPost = await intercepter.post(
        `${BASEURL}/stories/createStory`,
        data,
        config1,
      );

      setToast({
        show: true,
        type: "create",
        message: "created successfully",
      });
      // alert("successfull");
      nav("/");
    } catch (error) {
      console.log(error);
      // alert("failed");

      setToast({
        show: true,
        type: "none",
        message: "failed",
      });
    } finally {
      setToast({
        show: true,
        type: "none",
        message: "add image",
      });
    }
  };

  const validateVideo = (file) => {
    const MAX_SIZE_MB = 40;
    const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;

    return new Promise((resolve, reject) => {
      // 1. Check File Size first (Synchronous, fast)
      if (file.size > MAX_SIZE_BYTES) {
        return reject(`Video size must be less than ${MAX_SIZE_MB}MB`);
      }

      // 2. Check Duration (Asynchronous)
      const video = document.createElement("video");
      video.preload = "metadata";

      video.onloadedmetadata = () => {
        window.URL.revokeObjectURL(video.src);
        if (video.duration > 30) {
          reject("Video must be 30 seconds or less");
        } else {
          resolve(true);
        }
      };

      video.onerror = () => {
        window.URL.revokeObjectURL(video.src);
        reject("Invalid video file");
      };

      video.src = URL.createObjectURL(file);
    });
  };
  const handleChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return; // Handle cancel

    // 1. Clean up old memory to prevent memory leaks
    if (pic) URL.revokeObjectURL(pic);

    try {
      if (file.type.startsWith("video")) {
        await validateVideo(file);
      }

      // 2. Set both state values on success
      setImage(file);
      setPic(URL.createObjectURL(file));
      // setInvalidImage(null); // Clear any previous error messages
    } catch (err) {
      setToast({
        show: true,
        type: "none",
        message: err,
      });

      // 3. Reset everything on error so the UI stays in sync
      setImage(null);
      setPic("/images/uplodeImg.jpg");
    }
  };

  return (
    <>
      {pageType === "General" ? <Header /> : null}

      <div className="conatiner p-4">
        <div className="containerCreatePost">
          {!loading ? (
            <>
              <div className="text-center">
                <h3>Create Post </h3>

                <div className="mt-2 mt-md-0">
                  <button
                    onClick={postFeatch}
                    disabled={loading}
                    className="btn btn-primary px-4"
                    style={{ borderRadius: "12px" }}
                  >
                    Share
                  </button>

                  <button
                    onClick={postStory}
                    disabled={loading}
                    className="btn btn-outline-primary px-4 ms-2"
                    style={{ borderRadius: "12px" }}
                  >
                    Story
                  </button>
                </div>
              </div>
              <div className="userInfo">
                {invalidImage !== null ? (
                  <p className="text-danger"> {invalidImage} </p>
                ) : null}

                {/* <div className="w-75 createImgTop">
                  <SafeImage className="w-100" src={pic} alt="UploadImage" />
                </div> */}
                <div className="w-75 createImgTop">
                  {(pic && pic.includes("video")) ||
                  image?.type?.startsWith("video/") ? (
                    <video
                      src={pic}
                      controls
                      className="w-100"
                      style={{ maxHeight: "400px" }}
                    />
                  ) : (
                    <SafeImage className="w-100" src={pic} alt="UploadImage" />
                  )}
                </div>

                <div>
                  <input
                    type="file"
                    className="form-control"
                    name="upload_file"
                    accept="image/*,video/*"
                    // accept="image/*"
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="userInfo">
                <textarea
                  rows={5}
                  className="form-control"
                  placeholder="What's on your mind?"
                  onChange={(e) => setTitle(e.target.value)}
                  style={{
                    borderRadius: "16px",
                    padding: "15px",
                    resize: "none",
                  }}
                  maxLength={1000}
                />
              </div>
            </>
          ) : (
            <>
              <div className="loadingTop mt-5">
                <div className="loading"></div>
                <p className="fs-5">Loading...</p>
              </div>
            </>
          )}
        </div>
      </div>

      <MessageModal
        show={toast.show}
        message={toast.message}
        type={toast.type}
        onClose={() => setToast({ show: false, message: "", type: "" })}
      />
    </>
  );
}

export default Post;
